import { render } from "./BaseBadge.vue?vue&type=template&id=5de3df1c&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=5de3df1c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5de3df1c"

export default script